module.exports = __webpack_public_path__ + "img/freezingsnow.a1c8bcbb.png";